import type React from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router';
import type { TabsProps } from 'antd';
import 'styles/ant-design.css';
import { constructContractDetailPath } from 'constants/path';
import { useTranslation } from 'react-i18next';
import { getContractConfigTabs } from './contract-config-tabs';
import { useCallback, useMemo } from 'react';

interface NavigationTabsProps {
  contractId?: string;
  tabId?: string;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  contractId,
  tabId,
}) => {
  const { t } = useTranslation();
  const configTabs = getContractConfigTabs(t);
  const navigate = useNavigate();
  const location = useLocation();

  const onChange = useCallback(
    (key: string) => {
      navigate(constructContractDetailPath(contractId || '', key), {
        state: location.state,
      });
    },
    [navigate, contractId]
  );

  const items: TabsProps['items'] = useMemo(
    () =>
      configTabs.map((tab) => ({
        key: tab.id.toString(),
        label: tab.tab,
      })),
    [configTabs]
  );

  return (
    <div className="bg-[#E3F2FB] p-1 rounded-lg">
      <Tabs
        activeKey={tabId || '0'}
        onChange={onChange}
        items={items}
        className="custom-tabs custom-contract-tabs"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
        animated={false}
      />
    </div>
  );
};

export default NavigationTabs;
